import type { Base, SystemId } from '../../contracts/api'
import { SystemIcon } from './SystemIcon'

/** Цвет фишки-основания под систему (вариант chips). */
const CHIP_COLORS: Record<SystemId, { border: string; background: string; text: string }> = {
  bazi: { border: 'rgba(201,146,77,.35)', background: 'rgba(201,146,77,.10)', text: '#D9A868' },
  ziwei: { border: 'rgba(163,77,102,.35)', background: 'rgba(163,77,102,.10)', text: '#C87A90' },
  tzolkin: { border: 'rgba(63,201,180,.32)', background: 'rgba(63,201,180,.09)', text: '#4FD2BE' },
  iching: { border: 'rgba(233,228,214,.28)', background: 'rgba(233,228,214,.06)', text: '#D9D4C6' },
}

/**
 * «Из чего следует» — обязательная подпись под любым выводом Атласа: значок
 * системы, признак и, если есть, уточнение. Списком (rows) под карточкой или
 * фишками (chips) в подвале карточки дня.
 */
export function Bases({ items, variant = 'rows' }: { items: Base[]; variant?: 'rows' | 'chips' }) {
  if (items.length === 0) return null

  if (variant === 'chips') {
    return (
      <div className="bases-chips">
        {items.map((base) => (
          <span
            className="base-chip"
            key={base.label}
            style={{
              borderColor: CHIP_COLORS[base.system].border,
              background: CHIP_COLORS[base.system].background,
              color: CHIP_COLORS[base.system].text,
            }}
          >
            <SystemIcon system={base.system} size={16} />
            {base.label}
          </span>
        ))}
      </div>
    )
  }

  return (
    <div className="bases">
      {items.map((base) => (
        <div className="base-row" key={base.label}>
          <SystemIcon system={base.system} />
          <span>
            {base.label}
            {base.detail && <span className="base-detail"> — {base.detail}</span>}
          </span>
        </div>
      ))}
    </div>
  )
}
